import { SUNGLOW, RUSTY_RED } from '../../../../../helpers/constants';
import { ErrorType, REQUIRED_FIELD_ERROR_MESSAGE } from '../../../../../templateeditor/components/FieldValidations/constants';
import { ErrorSettings, FieldPosition, TemplatePage } from '../../../../../types/template-types';

const BASE_TRIANGLE_SIZE = 25;
const MIN_TRIANGLE_SIZE = 15;

export const calculateActualScreenXPosition = (x: number, page: TemplatePage, fieldPosition: FieldPosition, zoomLevel: number): number => {
  let actualScreenX = x;
  if (page && fieldPosition && zoomLevel) {
    const pageElement = document.getElementById(page.id);
    if (pageElement) {
      const pageClientRect = pageElement.getBoundingClientRect();
      actualScreenX = fieldPosition.x * zoomLevel + pageClientRect.x;
    }
  }
  return actualScreenX;
};

export const calculateActualScreenYPosition = (y: number, page: TemplatePage, fieldPosition: FieldPosition, zoomLevel: number): number => {
  let actualScreenY = y;
  if (page && fieldPosition && zoomLevel) {
    const pageElement = document.getElementById(page.id);
    if (pageElement) {
      const pageClientRect = pageElement.getBoundingClientRect();
      actualScreenY = fieldPosition.y * zoomLevel + pageClientRect.y;
    }
  }
  return actualScreenY;
};

export const calculateTriangleSize = (width: number, height: number) => {
  const baseSize = Math.min(width * 0.1, height * 0.1);
  const triangleSize = Math.max(MIN_TRIANGLE_SIZE, Math.min(BASE_TRIANGLE_SIZE, baseSize));

  return {
    triangleWidth: triangleSize,
    triangleHeight: triangleSize,
    polygonPoints: `${width},0 ${width - triangleSize},0 ${width},${triangleSize}`
  };
};

export const calculateErrorDisplay = (errorSettings?: ErrorSettings, isMissingRequired?: boolean) => {
  const errorColor = errorSettings?.errorType === ErrorType.Warning ? SUNGLOW : RUSTY_RED;
  const errorMessage = isMissingRequired ? REQUIRED_FIELD_ERROR_MESSAGE : errorSettings?.errorMessage || '';
  const borderColor = isMissingRequired ? RUSTY_RED : errorColor;

  return {
    errorColor,
    errorMessage,
    borderColor
  };
};

export const isMobileDevice = (): RegExpMatchArray => {
  const regExp = {
    mobile:
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/g
  };
  const userAgent = navigator.userAgent;
  return userAgent.match(regExp.mobile);
};
